import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import ProductTicketContainer from './ProductTicketContainer';
import ProductTicketFooter from './ProductTicketFooter';
import { useProductTicketStyles } from './styles';

const ProductTicket = ({ ...props }) => {
  const { tickets, mobile } = props;
  const classes = useProductTicketStyles({ mobile });
  return (
    <Box className={classes.container}>
      {tickets.map((ticket, index) => (
        <ProductTicketContainer key={index} ticket={ticket} />
      ))}
      <ProductTicketFooter mobile={mobile} />
    </Box>
  );
};

ProductTicket.propTypes = {
  tickets: PropTypes.array,
  mobile: PropTypes.bool,
};

export default ProductTicket;
